import { Box, Grid, Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { useEffect, useMemo, useState } from 'react';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';
import _ from 'lodash';
import { TopBox } from './TopBox';
import { bottomCategories, topCategories } from 'constants/balance.constants';
import { BottomBox } from './BottomBox';
import { BeneficiaryDateFilter } from './BeneficiaryDateFilter';
import { BeneficiaryResponseBox } from './BeneficiaryResponseBox';
import { BeneficiaryStatusBox } from './BeneficiaryStatusBox';
import React from 'react';

export const DashboardBalances = () => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const balancePermission = hasPermission([permissionEnums.DASHBOARD_BALANCES]);
	return (
		<Stack sx={{ position: 'relative' }}>
			<Grid container spacing={3}>
				{balancePermission &&
					topCategories.map((category, index) => {
						return (
							<Grid
								item
								key={index}
								style={{
									flexBasis: '50%',
								}}
							>
								<TopBox category={category} />
							</Grid>
						);
					})}

				{balancePermission &&
					bottomCategories.map((category, index) => (
						<React.Fragment key={index}>
							<Grid
								item
								style={{
									flexBasis: '23%',
								}}
							>
								<BottomBox category={category} />
							</Grid>
							{index === 2 && (
								<Grid
									item
									style={{
										flexBasis: '8%',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									<img src="/icons/equal-sign-green.svg" alt="Equal Sign" />
								</Grid>
							)}
						</React.Fragment>
					))}
				<Grid item xs={12} sx={{ mt: '38px' }}>
					<Stack spacing={2}>
						<BeneficiaryDateFilter />
						<Grid container spacing={3}>
							<Grid item xs={6}>
								<BeneficiaryStatusBox />
							</Grid>
							<Grid item xs={6}>
								<BeneficiaryResponseBox />
							</Grid>
							{[0, 1].map((slot) => (
								<Grid item xs={6} key={slot}>
									<Box
										sx={{
											boxShadow: '0px 0px 16px 0px #003A3526',
											borderRadius: '8px',
											height: 280,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<Typography variant="subtitle1">
											{t('page.dashboard.dashboardBalances.infoWillBeShownSoon')}
										</Typography>
									</Box>
								</Grid>
							))}
						</Grid>
					</Stack>
				</Grid>
			</Grid>
		</Stack>
	);
};
